module.exports = __webpack_public_path__ + "img/1777538c3d_79650151f0.dac0b68d.webp";